
import React from 'react';
import { observer } from 'mobx-react-lite';

import Table from '@vromo/ui/components/Table';
import { IntegrationRow } from '../components';
import { useIntegrationsPage } from '../hooks';



export const IntegrationList = observer(() => {

    const { fetchedIntegrations } = useIntegrationsPage()

    return (
        <Table>
            <thead>
                <tr>
                    <th colSpan={2}>Platform</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                {Array.from(fetchedIntegrations.values()).map((instance, index) => (
                    <IntegrationRow
                        key={`integration-${index}`}
                        platform={instance.platform}
                    />
                ))}
            </tbody>
        </Table>
    );
});
